<template>
	<div id="english">
		<NavigationBar />

		<!-- <Breadcrumb :productName="Breadcrumb.productName" /> -->


		<BahasaComponen :description = "BahasaComponen.description"
								:features = "BahasaComponen.features"
								:link = "BahasaComponen.link"
								:img = "BahasaComponen.img"
								:imgScale = "BahasaComponen.imgScale"
								:imgPositionX = "BahasaComponen.imgPositionX"
								:imgPositionY = "BahasaComponen.imgPositionY"
								:spesification = "BahasaComponen.spesification" />

		<div class="uk-section uk-padding-remove">
			<hr>
		</div>

		<!-- <div class="uk-section">
			<div class="uk-container">
				<div class="uk-flex uk-flex-middle uk-margin-remove-left" uk-grid>
					<router-link to="" class="uk-button uk-button-primary uk-margin-auto" style="border-radius: 10px;x">
						<h3 class="uk-text-uppercase" style="color: rgb(255, 255, 255); padding: 1vw;">buy now</h3>
					</router-link>
				</div>
			</div>
		</div>
 -->
		<Footer />
	</div>
</template>

<script>
import NavigationBar from '@/components/NavigationBar.vue'
import Breadcrumb from '@/components/Breadcrumb.vue'
import Footer from '@/components/Footer.vue'
import MainBannerProduct from '@/components/MainBannerProduct.vue'
import DownloadBanner from '@/components/DownloadBanner.vue'
// import BahasaComponen	from '@/components/BahasaComponen.vue'
import BahasaComponen from '@/components/BahasaComponen.vue'

export default {
	name: 'about',
	components: {
		NavigationBar,
		Breadcrumb,
		MainBannerProduct,
		DownloadBanner,
		// BahasaComponen,
		BahasaComponen,
		Footer
	},
	data () {
		return {
			Breadcrumb: {
				productName: 'about'
			},
			banner: {
				productName: 'lumio',
				tagline: 'your smart home lighting',
				features: ['lighting', 'remote connectivity', 'app control', 'vibrant colors'],
				link: 'https://youtu.be/X-p20C2mugs',
				img: 'lumio-banner-1.png',
				posTop: '-150px',
				posBottom: '-330px',
				imageScale: 'scale(1.2)'
			},
			BahasaComponen: {
				description: 'Adjust to any color to suit your mood or occasion.',
				features: [
					'Warm and Cool Lightning.',
					'Multiple color option.',
					'Contorl Switch from Smart Devices.',
					'Adjustable Brightness (Dim).',
					'Music Synchronization.',
					'Auto timer.',
					'App Connectivity on iOS & Android Devices.'
				],
				price: 'Rp. 123.500,00 include gst',
				link: '',
				img: require('../assets/kls.jpg'),
				imgScale: 'scale(.7)',
				imgTransformX: 'right',
				imgPositionY: '0',
				spesification: [
					{
						title: 'Model',
						subtitle: 'ABCDE123'
					},
					{
						title: 'Dimension',
						subtitle: ['12 x 34 x 56mm', '(12 x 34 x 56in)']
					},
					{
						title: 'Wireless Protocol',
						subtitle: ['2.4GHz WiFi router','Doesn\u2019t support the 5GHz']
					},
					{
						title: 'IC',
						subtitle: '123456-ABCDE123'
					},
					{
						title: 'Color',
						subtitle: 'White'
					},
					{
						title: 'Operating Temperature',
						subtitle: '-10\xB0 - +40\xB0C (14\xB0F - +104\xB0F)'
					},
					{
						title: 'Whats Included',
						subtitle: 'USB Power Adapter, USB Cable, Bracket, Screws, Reset Pin, Manual Book, Adhesive Tape.'
					},
					{
						title: 'App Support',
						subtitle: 'Roomi App (Apple iOS 10.3 or later, Android 5.0 or later).'
					},
					{
						title: 'Main Material',
						subtitle: 'ABC + DE'
					},
					{
						title: 'Operating Humidity',
						subtitle: ['0% - 95% RH', 'non condesing']
					},
					{
						title: 'CMIIT ID',
						subtitle: '123ABC456'
					},
					{
						title: 'Weight',
						subtitle: '123.45g'
					},
					{
						title: 'Power Usage',
						subtitle: 'DC 5V\xB110%'
					},
					{
						title: 'FCC ID',
						subtitle: '123-456ABC789'
					},

				]
			}
		}
	}
}
</script>

<style>

</style>